import { getColorsForLanguage } from './colorUtils';

export const getSortValue = {
  originalIndex: (item) => {
    if (item.originalIndex !== undefined) return item.originalIndex;
    if (item.cables) return Math.min(...item.cables.map(c => c.originalIndex));
    return 0;
  },

  siglatura: (item) => {
    if (item.poli && Array.isArray(item.poli)) {
      return item.nomeCavo || '';
    }
    if (item.siglatura) return item.siglatura;
    if (item.cables) return item.cables[0].siglatura || item.cables[0].nomeCavo || '';
    return '';
  },

  sezione: (item) => {
    if (item.poli && Array.isArray(item.poli)) {
      return item.poli[0]?.sezione || 0;
    }
    if (item.sezione !== undefined) return item.sezione;
    if (item.cables) return item.cables[0].sezione;
    return 0;
  },

  colore: (item) => {
    if (item.poli && Array.isArray(item.poli)) {
      return item.poli[0]?.colore || '';
    }
    if (item.colore) return item.colore;
    if (item.cables) return item.cables[0].colore;
    return '';
  },

  gruppo: (item) => {
    if (item.gruppo !== undefined) return item.gruppo || 'ZZZZZ';
    if (item.cables) return item.cables[0].gruppo || 'ZZZZZ';
    return 'ZZZZZ';
  }
};

export const comparators = {
  numeric: (a, b) => a - b,

  siglatura: (sigA, sigB) => {
    const numA = parseInt(sigA);
    const numB = parseInt(sigB);
    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB;
    }
    return String(sigA).localeCompare(String(sigB));
  },

  colore: (colorA, colorB, context) => {
    const idxA = context.colorOrder.indexOf(colorA);
    const idxB = context.colorOrder.indexOf(colorB);
    return idxA - idxB;
  },

  alphabetic: (a, b) => String(a).localeCompare(String(b))
};

export const sortCriteria = {
  numerazione: [
    {
      getValue: getSortValue.originalIndex,
      compare: comparators.numeric
    }
  ],

  siglatura: [
    {
      getValue: getSortValue.siglatura,
      compare: comparators.siglatura
    },
    {
      getValue: getSortValue.originalIndex,
      compare: comparators.numeric
    }
  ],

  colore: [
    {
      getValue: getSortValue.colore,
      compare: (a, b, context) => comparators.colore(a, b, context)
    },
    {
      getValue: getSortValue.originalIndex,
      compare: comparators.numeric
    }
  ],

  sezione: [
    {
      getValue: getSortValue.sezione,
      compare: comparators.numeric
    },
    {
      getValue: getSortValue.originalIndex,
      compare: comparators.numeric
    }
  ],

  coloreSezione: [
    {
      getValue: getSortValue.sezione,
      compare: comparators.numeric
    },
    {
      getValue: getSortValue.colore,
      compare: (a, b, context) => comparators.colore(a, b, context)
    },
    {
      getValue: getSortValue.originalIndex,
      compare: comparators.numeric
    }
  ],
  gruppo: [
    {
      getValue: getSortValue.gruppo,
      compare: comparators.alphabetic
    },
    {
      getValue: getSortValue.originalIndex,
      compare: comparators.numeric
    }
  ]
};

export const universalSort = (items, sortMode, context = {}) => {
  const criteria = sortCriteria[sortMode] || sortCriteria.numerazione;

  const sortedItems = [...items].sort((a, b) => {
    for (const criterion of criteria) {
      const valueA = criterion.getValue(a);
      const valueB = criterion.getValue(b);
      const result = criterion.compare(valueA, valueB, context);
      if (result !== 0) {
        return result;
      }
    }
    return 0;
  });

  return sortedItems;
};

export const createSortContext = (lingua) => ({
  colorOrder: getColorsForLanguage(lingua)
});
